<template>
  <div :class="$b()">
    <initiative-page>
      <template #logo>
        <router-link :to="{ name: 'login' }">
          <brand-logo :locale="locale" />
        </router-link>
      </template>

      <template #form>
        <slot />
      </template>

      <template #content>
        <video-section />
      </template>
    </initiative-page>

    <slot name="bottom-sections" />

    <footer v-once :class="$b('footer')">
      <small>© {{ currentYear }} Docplanner Group. All Rights Reserved.</small>
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';

import { BrandLogo, InitiativePage } from '@/ui';
import VideoSection from '@/modules/authentication/ui/components/VideoSection.vue';

@Component({
  name: 'LayoutForAuth',
  components: {
    BrandLogo,
    InitiativePage,
    VideoSection,
  },
})
export default class LayoutForAuth extends Vue {
  get locale() {
    return this.$i18n.locale;
  }

  get currentYear() {
    return new Date().getFullYear();
  }
}
</script>

<style lang="scss" scoped>
@use 'src/assets/scss/variables' as v;

.dp-layout-for-auth {
  &__footer {
    padding: v.$spacer-lg 0;
    color: v.$gray-500;
    text-align: center;
  }
}
</style>
